import { Flex, Text } from '@chakra-ui/react';

const SelfServePayoffLowAmountWarning = () => (
  <Flex flexDir="column" gap={1} textAlign="left" bg="leaseEndRedBG" borderRadius="md" p={2}>
    <Text color="leaseEndRed" fontWeight="bold">
      Double check your amount
    </Text>
    <Text>
      This should be your full payoff, the total to buy the car from your lienholder, not your
      remaining lease balance or monthly payment. Re-check the figure with your lender and re-enter
      it.
    </Text>
  </Flex>
);

export default SelfServePayoffLowAmountWarning;
